/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import BarraPc from "./BarraPc";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import BarraCell from "./BarraCell";


const Barra = () => {
    const {masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            {masSM ?
                <BarraPc/>
                :
                <BarraCell/>
            }


        </Grid>
    )

}
export default Barra    